<template>
  <div
    class="relative min-h-16 flex overflow-hidden group flex flex-col justify-center"
  >
    <h1 class="text-xl lg:text-3xl font-bold tracking-wide relative">
      <slot></slot>
    </h1>
    <p class="text-lg">
      <slot name="subtext"></slot>
    </p>
  </div>
</template>

<script setup lang="ts">
defineProps<{
  backgroundUrl?: string;
  subscribeLink?: string;
}>();
</script>
